import get from 'lodash/get'
import { IOption } from 'types/common'
import { Reset } from 'types/hookForm'
import {
  IDecisionPointLinkForm,
  IDecisionPointMediaWithRelations,
  IDecisionPointStepWithRelations,
  IDecisionPointWithRelations
} from 'interfaces/decisionPoint'
import { ITextContentWithRelations } from 'interfaces/textContent'

export function extractDecisionPoints(decisionPoints: IDecisionPointWithRelations[]): IDecisionPointLinkForm[] {
  return Array.isArray(decisionPoints)
    ? decisionPoints.map((decisionPoint: IDecisionPointWithRelations) => {
        return {
          content: decisionPoint?.title,
          linkedMedia: decisionPoint?.decisionPointMedias?.map(
            (decisionPointMedia: IDecisionPointMediaWithRelations) => decisionPointMedia?.media
          ),
          linkedSteps: decisionPoint?.decisionPointSteps?.map((decisionPointStep: IDecisionPointStepWithRelations) => {
            const stepOptions: IOption<number> = {
              label: decisionPointStep?.step?.name,
              value: decisionPointStep?.step?.id
            }
            return stepOptions
          })
        }
      })
    : []
}

export function getDefaultFormValues(reset: Reset, blockText: ITextContentWithRelations): void {
  reset({
    isDisableMediaLabel: blockText?.isDisableMediaLabel,
    decisionPoints: extractDecisionPoints(blockText?.decisionPoints),
    iconName: get(blockText, 'iconName', ''),
    iconId: get(blockText, 'iconId', '')
  })
}
